import { Dependency, DefaultDependencySettings } from "index";
import DependencyBase from "../DependecyBase";
import React from "react";

declare global {
    interface Window {
        CookieScript?: any;
    }
}
export interface CookieScriptSettings extends DefaultDependencySettings {
    scriptKey: string;
    helmetComponent: React.ComponentType;
}

class CookieScript extends DependencyBase<CookieScriptSettings> {
    static instance?: CookieScript;

    // This feels like a bit of a hack...
    static _componentDependencies: Dependency[] = [];
    public static dependency = () => this._componentDependencies.every((dependency) => dependency());

    constructor(prop: CookieScriptSettings) {
        super(prop);
        CookieScript._componentDependencies.push(this.dependency);
        CookieScript.instance = this;
    }

    // We save all events until the user has made a choice regarding consent.
    public dependency = () => !!window.CookieScript?.instance?.currentState?.()?.action;

    public static onScriptLoaded = () => {
        // We can't do anything here, since Cookiescript injects the consent settings directly into the dataLayer.
        // As long as the cookie consent mode is enabled in the Cookiescript UI, as they must be per their instructions.
    };

    render = () => {
        const { scriptKey, helmetComponent: Helmet } = this.props as CookieScriptSettings;

        return (
            <Helmet>
                <script>
                    {`
                        (function() {
                            const elements = document.getElementsByTagName('script')[0];
                            const script = document.createElement('script');
                            script.onload = function () {return window.grebban.gtm.scriptCallback('CookieScript');}
                            script.src = '//cdn.cookie-script.com/s/${scriptKey}.js';
                            script.type = 'text/javascript';
                            script.id = 'CookieScriptScript'
                            elements.parentNode.insertBefore(script, elements);
                        })();
                    `}
                </script>
            </Helmet>
        );
    };
}

export default CookieScript;
